import React, { useState, useEffect } from "react";
import { getDashboardPerPatient } from "../../services";
import { BarDashboard } from "../../components";

const PerPatient = (props) => {
  const { startDate, endDate, filter, locationId } = props;

  useEffect(() => {
    getDashboard();
  }, [startDate, endDate, filter]);

  const getDashboard = () => {
    getDashboardPerPatient(locationId, startDate, endDate, filter).then(
      (res) => {
        setData(res);
      }
    );
  };

  const [data, setData] = useState();

  if (data) {
    const departments = [];
    data.data.forEach((dep, value) => {
      departments.push(dep.x);
    });

    let format  = (v) => `${parseFloat(v/1000).toFixed(2)} kg`;
    if (filter == 1) {
      format = (v) => `€${v}`;
    }

    return (
        <BarDashboard
          data={data.data}
          ticks={departments}
          format={format}
        />
    );
  } else {
    return <div></div>;
  }
};

export default PerPatient;
